import React from 'react';
import { connect } from 'react-redux';

import { moveVideoCreator } from 'creators/shareVideo';

import DashboardMoveModal from 'components/videos-dashboard/move-modal';

class MoveModal extends React.Component {
  render() {
    // If video has no folder, user is anon and cannot move video
    if (!this.props.currentFolderId) {
      return null;
    }

    return (
      <DashboardMoveModal
        currentFolderId={this.props.currentFolderId}
        onMove={this.props.onMove}
      />
    );
  }
}

const mapStateToProps = state => {
  const videoFolder = state.share_video.video_folders.slice(-1)[0];

  return {
    currentFolderId: videoFolder ? videoFolder.id : null,
  };
};

const mapStateToDispatch = dispatch => ({
  onMove: (toFolderId, toFolderName) =>
    dispatch(moveVideoCreator(toFolderId, toFolderName)),
});

export default connect(mapStateToProps, mapStateToDispatch)(MoveModal);
